<script>
import appConfig from "@/app.config";

export default {
  page: {
    title: "جرئیات توسعه دهنده",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  computed: {
    totalData() {
      return [
        {
          name: "اپلیکیشن",
          data: this.record.applicationsCount,
          icon: "ri-apps-line",
          bg: "bg-success",
        },
        {
          name: "کمپین",
          data:
            this.record.activeCampaignsCount +
            this.record.inactiveCampaignsCount +
            this.record.awaitingApprovalCampaignsCount,
          icon: "ri-advertisement-line",
          bg: "bg-primary",
        },
        {
          name: "لیگ",
          data:
            this.record.activeLeaguesCount +
            this.record.inactiveLeaguesCount +
            this.record.awaitingApprovalLeaguesCount,
          icon: "ri-gamepad-line",
          bg: "bg-warning",
        },
        {
          name: "نوتیفیکیشن",
          data:
            this.record.sendNotificationsCount +
            this.record.notSendNotificationsCount +
            this.record.awaitingApprovalNotificationsCount,
          icon: "ri-notification-line",
          bg: "bg-danger",
        },
      ];
    },
    campaignSeries() {
      return [
        this.record.activeCampaignsCount,
        this.record.inactiveCampaignsCount,
        this.record.awaitingApprovalCampaignsCount,
      ];
    },
    leagueSeries() {
      return [
        this.record.activeLeaguesCount,
        this.record.inactiveLeaguesCount,
        this.record.awaitingApprovalLeaguesCount,
      ];
    },
    notificationSeries() {
      return [
        this.record.sendNotificationsCount,
        this.record.notSendNotificationsCount,
        this.record.awaitingApprovalNotificationsCount,
      ];
    },
    dataUsageSeries() {
      return [
        Math.round(this.record.applicationsDatabaseSize * 100) / 100,
        Math.round(this.record.leaguesDatabaseSize * 100) / 100,
      ];
    },
  },
  data() {
    return {
      title: "جرئیات توسعه دهنده",
      items: [
        {
          text: "لیست توسعه دهندگان",
          to: { name: "developers" },
        },
        {
          text: "جرئیات توسعه دهنده",
          active: true,
        },
      ],
      record: null,
      chartOptions: {
        chart: {
          height: 230,
          type: "donut",
        },
        labels: [],
        plotOptions: {
          pie: {
            donut: {
              size: "75%",
            },
          },
        },
        dataLabels: {
          enabled: false,
        },
        legend: {
          show: true,
        },
        colors: [
          "#f63e3e",
          "#eeb902",
          "#1cbb8c",
          "#5664d2",
          "#03d3fc",
          "#fc6f03",
          "#b2c8d9",
          "#c969be",
          "#03ffc4",
        ],
        tooltip: {
          y: {
            formatter: function(value) {
              let Number = value;
              Number += "";
              Number = Number.replace(",", "");
              const x = Number.split(".");
              let y = x[0];
              const z = x.length > 1 ? "." + x[1] : "";
              const rgx = /(\d+)(\d{3})/;
              while (rgx.test(y)) y = y.replace(rgx, "$1" + "," + "$2");
              return y + z + " عدد";
            },
          },
        },
      },
      campaignChartLabels: ["فعال", "غیر فعال", "در انتظار تایید"],
      leagueChartLabels: ["فعال", "غیرفعال", "در انتظار تایید"],
      notificationChartLabel: ["ارسال شده", "ارسال نشده", "در انتظار تایید"],
      dataUsageChartOptions: {
        chart: {
          height: 230,
          type: "donut",
        },
        labels: ["اپلیکیشن ها", "لیگ ها"],
        plotOptions: {
          pie: {
            donut: {
              size: "75%",
            },
          },
        },
        dataLabels: {
          enabled: false,
        },
        legend: {
          show: true,
        },
        colors: [
          "#f63e3e",
          "#eeb902",
          "#1cbb8c",
          "#5664d2",
          "#03d3fc",
          "#fc6f03",
          "#b2c8d9",
          "#c969be",
          "#03ffc4",
        ],
        tooltip: {
          y: {
            formatter: function(value) {
              let Number = value;
              Number += "";
              Number = Number.replace(",", "");
              const x = Number.split(".");
              let y = x[0];
              const z = x.length > 1 ? "." + x[1] : "";
              const rgx = /(\d+)(\d{3})/;
              while (rgx.test(y)) y = y.replace(rgx, "$1" + "," + "$2");
              return y + z + " مگابایت";
            },
          },
        },
      },
    };
  },
  mounted() {
    this.fetchRecord();
  },
  methods: {
    fetchRecord() {
      this.$axios.get(`developers/${this.$route.params.id}`).then((res) => {
        this.record = res.data;
      });
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div v-if="record !== null" class="row">
      <div class="col-md-3" v-for="data in totalData" :key="data.name">
        <div class="card">
          <div :class="`card-body rounded-lg ${data.bg}`">
            <div class="media">
              <div class="media-body overflow-hidden">
                <p class="text-truncate text-white font-size-14 mb-2">
                  {{ data.name }}
                </p>
                <h4 class="text-white mb-0">{{ data.data }}</h4>
              </div>
              <div class="text-white">
                <i :class="`${data.icon} font-size-24`"></i>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-6">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">آمار کمپین ها</h4>
            <div id="campaigns-chart" class="apex-charts"></div>
            <apexchart
              class="apex-charts"
              height="230"
              dir="rtl"
              :series="campaignSeries"
              :options="{ ...chartOptions, ...{ labels: campaignChartLabels } }"
            ></apexchart>
            <div class="row flex flex-wrap">
              <div :key="i" class="mx-2" v-for="(item, i) in campaignSeries">
                <div class="text-center mt-4">
                  <p class="mb-2 text-truncate">
                    <i
                      class="mdi mdi-circle font-size-10 mr-1"
                      :style="{ color: chartOptions.colors[i] }"
                    ></i>
                    {{ campaignChartLabels[i] }}
                  </p>
                  <h5>
                    {{
                      item !== 0
                        ? Math.round((item * 100) / totalData[1].data)
                        : 0
                    }}%
                  </h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">آمار لیگ ها</h4>
            <div id="leagues-chart" class="apex-charts"></div>
            <apexchart
              class="apex-charts"
              height="230"
              dir="rtl"
              :series="leagueSeries"
              :options="{ ...chartOptions, ...{ labels: leagueChartLabels } }"
            ></apexchart>
            <div class="row flex flex-wrap">
              <div :key="i" class="mx-2" v-for="(item, i) in leagueSeries">
                <div class="text-center mt-4">
                  <p class="mb-2 text-truncate">
                    <i
                      class="mdi mdi-circle font-size-10 mr-1"
                      :style="{ color: chartOptions.colors[i] }"
                    ></i>
                    {{ leagueChartLabels[i] }}
                  </p>
                  <h5>
                    {{
                      item !== 0
                        ? Math.round((item * 100) / totalData[2].data)
                        : 0
                    }}%
                  </h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">آمار نوتیفیکشن ها</h4>
            <div id="notifications-chart" class="apex-charts"></div>
            <apexchart
              class="apex-charts"
              height="230"
              dir="rtl"
              :series="notificationSeries"
              :options="{
                ...chartOptions,
                ...{ labels: notificationChartLabel },
              }"
            ></apexchart>
            <div class="row flex flex-wrap">
              <div
                :key="i"
                class="mx-2"
                v-for="(item, i) in notificationSeries"
              >
                <div class="text-center mt-4">
                  <p class="mb-2 text-truncate">
                    <i
                      class="mdi mdi-circle font-size-10 mr-1"
                      :style="{ color: chartOptions.colors[i] }"
                    ></i>
                    {{ notificationChartLabel[i] }}
                  </p>
                  <h5>
                    {{
                      item !== 0
                        ? Math.round((item * 100) / totalData[3].data)
                        : 0
                    }}%
                  </h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">آمار استفاده از سرور</h4>
            <div id="data-usage-chart" class="apex-charts"></div>
            <apexchart
              class="apex-charts"
              height="230"
              dir="rtl"
              :series="dataUsageSeries"
              :options="dataUsageChartOptions"
            ></apexchart>
            <div class="row flex flex-wrap">
              <div :key="i" class="mx-2" v-for="(item, i) in dataUsageSeries">
                <div class="text-center mt-4">
                  <p class="mb-2 text-truncate">
                    <i
                      class="mdi mdi-circle font-size-10 mr-1"
                      :style="{ color: chartOptions.colors[i] }"
                    ></i>
                    {{ dataUsageChartOptions.labels[i] }}
                  </p>
                  <h5>
                    {{
                      item !== 0
                        ? Math.round(
                            (item * 100) /
                              (record.applicationsDatabaseSize +
                                record.leaguesDatabaseSize)
                          )
                        : 0
                    }}%
                  </h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
